export default __webpack_public_path__ + "static/media/3.bad77305.png";